import PropTypes from 'prop-types';
import React from 'react';
import { isPercentagePromo } from '../selectors';
import Money from '../../../../common/money';

const PromoValue = ({ promoCode, ...props }) => {
  if (isPercentagePromo(promoCode)) {
    return (<span {...props}>{promoCode.value}%</span>);
  }

  return (<Money cents={promoCode.value} {...props} />);
};

PromoValue.propTypes = {
  promoCode: PropTypes.object.isRequired,
};

export default PromoValue;
